import { BUSINESS } from "../lib/business";
import { LegalLink } from "./Legal";

export const Footer = () => {
    return (
        <footer
            data-testid="site-footer"
            className="bg-[#0F172A] border-t border-white/10 text-slate-400 py-12"
        >
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid md:grid-cols-3 gap-8">
                <div>
                    <div className="flex items-center gap-2">
                        <span className="relative flex items-center justify-center w-9 h-9 rounded-lg bg-[#0055FF] text-white font-black text-lg">
                            K
                            <span className="absolute -top-1 -right-1 w-2.5 h-2.5 rounded-full bg-[#25D366] live-dot ring-2 ring-[#0F172A]" />
                        </span>
                        <div className="text-white font-extrabold tracking-tight">{BUSINESS.name}</div>
                    </div>
                    <p className="mt-3 text-sm leading-relaxed">
                        Kayseri'de 7/24 su tesisatçısı hizmeti. Tıkanıklık açma, su kaçağı tespiti, kombi
                        tamiri ve banyo-mutfak tesisatı. Hızlı, garantili, uygun fiyat.
                    </p>
                </div>

                <div>
                    <div className="text-xs font-bold uppercase tracking-widest text-slate-300">Hizmetler</div>
                    <ul className="mt-3 space-y-2 text-sm">
                        <li><a href="#hizmetler" className="hover:text-white transition-colors">Tıkanıklık Açma</a></li>
                        <li><a href="#hizmetler" className="hover:text-white transition-colors">Su Kaçağı Tespiti</a></li>
                        <li><a href="#hizmetler" className="hover:text-white transition-colors">Kombi & Petek Tamiri</a></li>
                        <li><a href="#hizmetler" className="hover:text-white transition-colors">Banyo & Mutfak Tesisatı</a></li>
                        <li><a href="#hizmetler" className="hover:text-white transition-colors">7/24 Acil Tesisatçı</a></li>
                    </ul>
                </div>

                <div>
                    <div className="text-xs font-bold uppercase tracking-widest text-slate-300">Bilgi</div>
                    <ul className="mt-3 space-y-2 text-sm">
                        <li><a href="#hakkinda" className="hover:text-white transition-colors">Hakkımızda</a></li>
                        <li><a href="#bolgeler" className="hover:text-white transition-colors">Hizmet Bölgeleri</a></li>
                        <li><a href="#sss" className="hover:text-white transition-colors">Sık Sorulan Sorular</a></li>
                        <li><LegalLink kind="privacy">Gizlilik Politikası / KVKK</LegalLink></li>
                        <li><LegalLink kind="terms">Hizmet Şartları</LegalLink></li>
                    </ul>
                </div>
            </div>

            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-10 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs">
                <div className="flex items-center gap-2">
                    <span className="relative flex w-2 h-2">
                        <span className="absolute inline-flex w-full h-full rounded-full bg-[#25D366] opacity-75 animate-ping" />
                        <span className="relative inline-flex w-2 h-2 rounded-full bg-[#25D366]" />
                    </span>
                    <span>© {new Date().getFullYear()} {BUSINESS.name} · Tüm hakları saklıdır.</span>
                </div>
                <div className="uppercase tracking-widest font-bold text-slate-500">
                    Kayseri · 7/24 Tesisatçı Servisi
                </div>
            </div>
        </footer>
    );
};

export default Footer;
